module.exports = __webpack_public_path__ + "static/client_2.1_after-fe431da3f382bcbc59ed47b35af5258d.jpg";